"use client";
import { ThemeOptions } from "@mui/material/styles/createTheme";
import { createTheme } from "@mui/material/styles";

const themeOptions: ThemeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: "#060273",
      light: "#EDF1FF",
      dark: "#3933E6",
    },
    secondary: {
      main: "#B82025",
      light: "#FFE9EB",
      dark: "#FF4343",
    },
    // success: {},
    // warning: {},
    // info: {},
    // error: {},
    // background: {},
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        color: "secondary",
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 42,
          height: 26,
          padding: 0,
          margin: 8,
        },
        switchBase: {
          padding: 1,
          "&$checked, &$colorPrimary$checked, &$colorSecondary$checked": {
            transform: "translateX(16px)",
            color: "#fff",
            "& + $track": {
              opacity: 1,
              border: "none",
            },
          },
        },
        thumb: {
          width: 24,
          height: 24,
        },
        track: {
          borderRadius: 13,
          border: "1px solid #bdbdbd",
          backgroundColor: "#fafafa",
          opacity: 1,
          transition:
            "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        variant: "contained",
        disableElevation: true,
      },
    },
    MuiContainer: {
      defaultProps: {
        maxWidth: "xl",
        sx: { pb: "1rem", pt: "1rem" },
      },
    },
    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true,
      },
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: "inherit",
    h1: {
      fontWeight: "700",
      fontFamily: "'blauerNue', 'blauerNue Fallback'",
    },
    h2: {
      fontWeight: "700",
      fontFamily: "'blauerNue', 'blauerNue Fallback'",
    },
    h3: {
      fontWeight: "700",
      fontFamily: "'blauerNue', 'blauerNue Fallback'",
    },
    h4: {
      fontWeight: "700",
      fontFamily: "'blauerNue', 'blauerNue Fallback'",
    },
    h5: {
      fontWeight: "700",
      fontFamily: "'blauerNue', 'blauerNue Fallback'",
    },
    h6: {
      fontWeight: "700",
      fontFamily: "'Roboto', 'Roboto Fallback'",
    },
    body1: {
      fontWeight: "400",
      fontSize: "16px",
      fontFamily: "'Roboto', 'Roboto Fallback'",
    },
    body2: {
      fontWeight: "400",
      fontSize: "14px",
      fontFamily: "'Roboto', 'Roboto Fallback'",
    },
    subtitle1: {
      fontWeight: "600",
      fontFamily: "'blauerNue', 'blauerNue Fallback'",
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: "14px",
      fontFamily: "'blauerNue', 'blauerNue Fallback'",
    },
    // | 'body1'
    // | 'body2'
    // | 'caption'
    // | 'button'
    // | 'overline';
  },
};

const theme = createTheme({
  ...themeOptions,
  palette: {
    ...themeOptions.palette,
    mode: "light",
  },
});

export default theme;
